import {computed, Injectable, signal} from '@angular/core';
import { Timer } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class TimerService {
  private timerCount = signal<number>(0);

  readonly timer = computed(() =>
    this.calculateTime(this.timerCount())
  );

  readonly timerStatus = signal<boolean>(false);

  private intervalId: ReturnType<typeof setInterval> | null = null;

  startTimer(seconds: number) {
    this.stopTimer();

    this.timerCount.set(seconds);
    this.timerStatus.set(true);

    this.intervalId = setInterval(() => {
      const newValue = Math.max(this.timerCount() - 1, 0);
      this.timerCount.set(newValue);

      if (newValue <= 0) {
        this.stopTimer();
      }
    }, 1000);
  }

  stopTimer() {
    if (this.intervalId !== null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    this.timerCount.set(0);
    this.timerStatus.set(false);
  }

  private calculateTime(seconds: number): Timer {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return {
      hoursLeft: hours,
      minutesLeft: minutes,
      secondsLeft: secs,
    };
  }
}
